/**
 * Reaction types for posts and replies
 * Must match backend ReactionTypeEnum
 */
const ReactionTypeEnumValue = {
  LIKE: 1,
  LOVE: 2,
  HELPFUL: 3,
  RESOLVED: 4,
};

export default ReactionTypeEnumValue;

/**
 * Get icon and label for reaction type
 */
export const getReactionConfig = reactionType => {
  switch (reactionType) {
    case ReactionTypeEnumValue.LIKE:
      return { icon: '👍', label: 'Like', color: '#4267B2' };
    case ReactionTypeEnumValue.LOVE:
      return { icon: '❤️', label: 'Love', color: '#F02849' };
    case ReactionTypeEnumValue.HELPFUL:
      return { icon: '💡', label: 'Helpful', color: '#FFD200' };
    case ReactionTypeEnumValue.RESOLVED:
      return { icon: '✅', label: 'Resolved', color: '#4CAF50' };
    default:
      return { icon: '👍', label: 'React', color: '#888' };
  }
};
